import { ReactElement, useContext, useEffect } from 'react'

import { TabsContext } from '@/lib/core/components/Tabs'

export type TabProps = {
  value: string
  children: (renderProps: TabRenderProps) => ReactElement<unknown>
}

export type TabRenderProps = {
  activeTab: string
  registerTabValue: (tabValue: string) => string
  setActiveTab: (newActiveTab: string) => string
  tabValues: Array<string>
  unregisterTabValue: (tabValue: string) => void
}

export const TabComponent = ({ value, children }: TabProps) => {
  const { activeTab, registerTabValue, setActiveTab, tabValues, unregisterTabValue } =
    useContext(TabsContext)

  useEffect(() => {
    registerTabValue(value)

    return () => unregisterTabValue(value)
  }, [])

  return children({
    activeTab,
    registerTabValue,
    setActiveTab,
    tabValues,
    unregisterTabValue,
  })
}
